import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Switch, } from 'antd'

import { getMerchantCategory, addMerchantCategory, reviseMerchantCategory, deletMerchantCategory } from '_src/api/api'

const { confirm } = Modal
@Form.create({ name: 'goodsTip' })
class goodsTip extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.param = {
      status: '',
      pageNum: 0,
      totalElements: 0
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      loading: true,
      visible: false,
      dataList: [],
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    this.setState(()=>({
      loading: true
    }))
    const { status, pageNum }= this.param
    getMerchantCategory({status: status, pageSize: 10, pageNum: pageNum})
      .then(res=>{
        const { data } = res
        const { content, totalElements } = data
        this.param.totalElements = totalElements
        const dataList = content.map((item, index)=>{
          return {...item, key: item.id, sort: (index+1)}
        })
        this.setState({
          dataList: dataList,
          visible: false,
          loading: false
        })
      })
  }
  columns = () => {
    return [
      {
        title: <span>排序</span>,
        align: 'center',
        dataIndex: 'sort',
        key: 'sort',
      },
      {
        title: <span>商品标签</span>,
        align: 'center',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: <span>标签颜色</span>,
        align: 'center',
        dataIndex: 'commissionRatio',
        key: 'commissionRatio',
      },
      {
        title: <span>创建时间</span>,
        align: 'center',
        dataIndex: 'createAt',
        // render: item => <div>{item ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>是否启用</span>,
        align: 'center',
        dataIndex: 'status',
        render: item => (
          <div>{item === 1 
            ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> 
            : <Icon type="close-circle" theme="filled" style={{color: '#ccc', fontSize: 20}} /> }</div>)
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
          <Button icon="form" type='primary' onClick={()=>{ this.onEdit(record) }} style = {{marginRight: 10}}>编辑</Button>
          <Button icon="delete" type='danger' onClick={()=>{ this.handleDelete(record) }} style = {{marginRight: 10}}>删除</Button>
        </div>,
      },
    ]
  }


  handleCancel = () => this.setState({ previewVisible: false })
  onEdit (record) {
    this.setState(()=>({
      erroMsg: '',
    }))
    const { id } = record || ''
  
    this.id = id || ''
    this.upLoadFlage = !toString(this.id) // 重置更新状态
    this.setState({
      visible: true,
      
    }, ()=>{
      const { status, name,commissionRatio } = record || {}
      // 设置对话框信息
      this.props.form.setFieldsValue({
        status: !!status,
        name,
        commissionRatio
      })
    })
  }

  handleDelete = (record) => {
    const { id, name} = record || ''
    this.id = id || ''
    const _self = this
    confirm({
      title: '温馨提示',
      content: (<p>你确定要删除商户类型 <strong style = {{color: 'red'}}>{name}</strong>吗？</p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        deletMerchantCategory(id)
          .then(()=>{
            _self.loadData()
          })
      },
      onCancel () {
      },
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const title = '商户类型'
        this.hide = message.loading(this.id?`${title}修改中`:`${title}添加中`, 0)
        // 需要更新图片
        values.commissionRatio = Number(values.commissionRatio)
        let param = values
        let { status } = param
        status = status? 1 : 0
        param = {...param, status}
        this.handleReturnCause({...param})  
        this.setState({
          erroMsg: ''
        })
      }
    })
  }

  // 保存专题
  handleReturnCause (param) {
    if (!this.id) {
      // 添加
      addMerchantCategory(param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('添加成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          // this.loadData()
          message.success('添加失败', 1.5)
        })
    }
    else {
      // 修改
      reviseMerchantCategory(this.id, param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('修改成功·=', 1.5)
        })
        .catch(()=>{
          this.hide()
          message.success('修改失败', 1.5, ()=>{
            this.loadData()
          })
        })
    }
  }

  handleEditCancel = () => {
    this.setState({ visible: false })
  }
  // handleSearch = (e) => {
  //   this.param.status = e.target.value
  //   this.param.pageNum = 0
  //   this.loadData()
  // }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, visible, loading } = this.state
    const { getFieldDecorator } = this.props.form

    return (
      <div className = "page_content">
        <div className = "simple_top">
          <Button type = "primary" icon="plus" onClick = { () => { this.onEdit() } }>添加</Button>
          {/* <Radio.Group defaultValue="" buttonStyle="solid" className = 'searchSelect'
            onChange = { this.handleSearch }
          >
            <Radio.Button value="">全部</Radio.Button>
            <Radio.Button value={1}>显示状态</Radio.Button>
            <Radio.Button value={0}>禁用状态</Radio.Button>
          </Radio.Group> */}
        </div>
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (this.param.pageNum + 1),
            total: this.param.totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Modal
          title={ '商品类型名称设置'}
          width={600}
          visible={visible}
          onCancel={this.handleEditCancel}
          footer={false}
          destroyOnClose // 关闭时候销毁
        >
          <Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}>
            <Form.Item label="是否显示">
              {getFieldDecorator('status', { valuePropName: 'checked' })(
                <Switch />
              )}
            </Form.Item>

            <Form.Item label="类型名称" number>
              {getFieldDecorator('name', { rules: [{ required: true, message: '商户类型名称不能为空', }] })(
                <Input placeholder="请输入商户类型名称" />)}
            </Form.Item>
            <Form.Item label="抽佣比例" number>
              {getFieldDecorator('commissionRatio', { rules: [{ required: true, message: '抽佣比例不能为空', }] })(
                <Input placeholder="请输入抽佣比例，最大100，最小1" />)}
                 <p style={{textAlign:"center"}}>抽佣比例最大100，最小1</p>
            </Form.Item>
           
            <Form.Item style={{ paddingLeft: 140 }}>
              <Button type="primary" htmlType="submit" icon='save' style={{ width: 248, float: 'left'}}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default goodsTip